import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../context/AuthContext';
import { Trophy, Flame, Medal, Loader2 } from 'lucide-react';

export default function LeaderboardPage() {
  const [leaders, setLeaders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/leaderboard`)
      .then(res => setLeaders(res.data.leaderboard))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 text-primary animate-spin" /></div>
  );

  const getMedalColor = (i) => {
    if (i === 0) return 'text-yellow-400';
    if (i === 1) return 'text-gray-300';
    if (i === 2) return 'text-amber-600';
    return 'text-muted-foreground';
  };

  return (
    <div className="max-w-2xl mx-auto px-4 py-6 pb-20 md:pb-6" data-testid="leaderboard-page">
      <div className="flex items-center gap-2 mb-6">
        <Trophy className="w-6 h-6 text-zorki" />
        <h1 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight text-white">
          RANKING ŁOWCÓW
        </h1>
      </div>

      <div className="space-y-2">
        {leaders.map((user, i) => (
          <div
            key={user.id}
            className={`flex items-center gap-4 p-4 border transition-colors ${
              i < 3 ? 'bg-card border-primary/30' : 'bg-card border-border/40'
            }`}
            data-testid={`leader-${i}`}
          >
            <div className={`font-heading text-2xl font-extrabold w-10 text-center ${getMedalColor(i)}`}>
              {i < 3 ? <Medal className={`w-6 h-6 mx-auto ${getMedalColor(i)}`} /> : `#${i + 1}`}
            </div>
            <div className="w-10 h-10 rounded-full bg-secondary border border-border/40 flex items-center justify-center flex-shrink-0">
              <span className="font-heading font-bold text-primary">{user.nick?.charAt(0).toUpperCase()}</span>
            </div>
            <div className="flex-1 min-w-0">
              <span className="font-medium text-white text-sm">{user.nick}</span>
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                {user.badges?.slice(0, 3).map(b => (
                  <span key={b} className="text-primary/60">{b}</span>
                ))}
              </div>
            </div>
            <div className="flex items-center gap-1">
              <Flame className="w-4 h-4 text-zorki" />
              <span className="font-heading text-lg font-bold text-zorki">{user.zorki}</span>
            </div>
          </div>
        ))}

        {leaders.length === 0 && (
          <p className="text-center text-muted-foreground py-12">Brak użytkowników w rankingu</p>
        )}
      </div>
    </div>
  );
}
